const broadcastChannelConstants = {
    PUBLIC_CHANNEL: 'relayPublic',
    BROADCAST_ACTIVATED: 'broadcastActivated',
    BROADCAST_DEACTIVATED: 'broadcastDeactivated'
};
Object.freeze(broadcastChannelConstants);
export default broadcastChannelConstants;